//const apiUrl = "http://localhost:9000/";
const apiUrl = "/";

export default {
  apiUrl,
};
